import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { JobOpening } from '../../models/job-opening.interface';

@Component({
  selector: 'app-job-detail-info',
  standalone: false,
  templateUrl: './job-detail-info.component.html',
  styleUrls: ['./job-detail-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobDetailInfoComponent {
  @Input() job!: JobOpening;
}
